import { GetUserResponseBody } from "@/api/dto/users"

export const isStaffPlusRole = (role: GetUserResponseBody["role"]): boolean => {
	return role === "Admin" || role === "Staff"
}
